import { Box, Grid } from "@mui/material";
import { Container } from "@mui/system";
import React from "react";

import logoImg1 from "../../assets/logoImg1.png";
import logoImg2 from "../../assets/logoImg2.png";
import logoImg3 from "../../assets/logoImg3.png";
import logoImg4 from "../../assets/logoImg4.png";
import Marquee from "react-fast-marquee";

const logo = [logoImg1, logoImg2, logoImg3, logoImg4];

const Logo = () => {
  return (
    <Box sx={{ background: "#044474" }}>
      <Container>
        <Box>
          <Marquee
            pauseOnHover="true"
            speed="40"
            gradientColor="false"
            gradient="false"
          >
            <Grid container>
              {logo.map((logo) => {
                return (
                  <Grid item md={3} xs={3}>
                    <img src={logo} alt="LogoText1" width="100%" />
                  </Grid>
                );
              })}
            </Grid>
          </Marquee>
        </Box>
      </Container>
    </Box>
  );
};

export default Logo;
